import React from "react";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Description } from "@mui/icons-material";
import UsersManuals from "../../assets/UsersManual.pdf";

function ManualBox({ image, userType, sizeDoc }) {
  return (
    <div className="w-[45%] relative mb-10 bg-[#108757] flex p-9">
      <div className="basis-1/4 ">
        <img src={image} className="absolute w-1/3 h-2/3 -left-16" alt="" />
      </div>
      <div className="grow">
        <h2 className="text-2xl text-white py-3">
          Manuel d'utilisateur {userType}
        </h2>
        <span className="text-white inline-block w-full py-1 border-y-2 border-red-500">
          PDF
        </span>
        <div className="flex text-2xl py-4 items-center text-white">

          <span
            className="mr-8 cursor-pointer hover:text-white hover:opacity-50"
            onClick={() => window.open(UsersManuals)}
          >
            <Description /> Lire
          </span>
          <a
            className="text-inherit hover:opacity-50 hover:text-white"
            href={UsersManuals}
            download="Manuel-d-utilisation.pdf"
          >
            {" "}
            <span>
              {" "}
              <FileDownloadIcon />
              Telecharger
            </span>
          </a>
        </div>
      </div>
    </div>
  );
}

export default ManualBox;
